import { getPageInfo } from '@ynap/analytics';

export const trackPage = ({ analytics = {}, error = {}, prevPath, country, language, deviceType = 'website' }) => ({
    event: 'trackPage',
    page: {
        pageInfo: getPageInfo({ location: window.location, language, country, deviceType, pageName: `error - ${error?.status}`, prevUrl: prevPath }),
        category: {
            pageType: 'error page',
            primaryCategory: 'error page',
            subCategory1: 'error page',
            subCategory2: error?.status || '',
            subCategory3: error?.message || '',
            subCategory4: '',
        },
        attributes: {
            ...(analytics.page && analytics.page.attributes),
            errorDetails: error?.message || '',
        },
    },
    user: analytics.user || {},
});

export const trackRetry = () => ({
    event: 'error page link click',
    effect: 'navigate',
    category: {
        primaryCategory: 'error page',
        subCategory: 'retry',
    },
});
